import { createSlice } from "@reduxjs/toolkit";

const institutionLoginSlice = createSlice({
  name: "institutionLogin",
  initialState: { version: 0 },
  reducers: {
    institutionLoginUpdated: (state) => {
      state.version += 1;
    },
  },
});

export const { institutionLoginUpdated } = institutionLoginSlice.actions;

export default institutionLoginSlice.reducer;
